import _ from 'lodash'

export const BIRTH_REGEX_MASK = [
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
]

export const BIRTH_REGEX = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;

export const CEP_REGEX_MASK = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
]

export const PHONENUMBER_REGEX = /^\(\d{2}\) \d{4,5}-\d{3,4}$/

export const PHONENUMBER_REGEX_MASK = [
  '(', /[0-9]/, /[0-9]/, ')', ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/,
  /[0-9]/, 
  '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/
];


export const CNPJ_REGEX_MASK = [
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '/',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
]

export const CPF_REGEX_MASK = [
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '.',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
]

//
export interface IViaCepResponse {
  cep: string
  logradouro: string
  complemento: string
  bairro: string
  localidade: string
  uf: string
  unidade: string
  ibge: string
  gia: string
}

export const fetchCEPInfo = (cep: string) => {
  if (cep.length !== '80250-085'.length) return

  return fetch(`https://viacep.com.br/ws/${cep}/json/`).then<IViaCepResponse>((res) => res.json())
}

export const formDataGenerator = (data: FormData, object: any, path: string = '') => {
  _.forEach(object, (value, key) => {
    const _path = path ? `${path}[${key}]` : key

    value instanceof File || typeof value !== 'object'
      ? data.append(`${_path}`, value ?? '')
      : formDataGenerator(data, value, `${_path}`)
  })

  return data
}